import React, {ReactNode} from "react";
import InfoBar from "../../../components/TechStatus/InfoBar";
import GeneralActions from "../../Layout/GeneralActions";
import NavigationBar from "../NavigationBar/NavigationBar";
import { Box } from "@mui/material";
import GlobalProvider from "../../../components/Provider/GlobalProvider";
import PresenceProvider from "../../../provider/PresenceProvider";

type LayoutProps = {
  children: ReactNode;
};
const Layout = ({ children }: LayoutProps) => {
  return (
    <GlobalProvider>
      <PresenceProvider>
        <InfoBar />
        <NavigationBar />
        <Box
          sx={{
            margin: "2rem 1rem 5rem 1rem",
          }}
        >
          {children}
        </Box>
        <GeneralActions />
      </PresenceProvider>
    </GlobalProvider>
  );
};

export default Layout;
